import React from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

const Itinerary = ({ items }) => {
  return items.map(item => (
    <Row className="pb-4" key={item.title}>
      <Col xl={7} className="text-start ">
        <div className="mx-2 px-3">
          <h2 className="regular-text-bold-itinerary">
            <FormattedMessage id={item.title} />
          </h2>
          <p className="regular-text-itinerary mt-3">
            <FormattedMessage id={item.text} 
              values={{
                br: <br />,
              }}/>
          </p>
          {item.text2 && (
            <p className="regular-text-itinerary">
              <FormattedMessage
                id={item.text}
                values={{
                  br: <br />,
                }}
              />

            </p>
          )}
        </div>
      </Col>
      <Col xl={5} className="itinerary-img">
        <Image src={item.img} fluid />
      </Col>
    </Row>
  ));
};

export default Itinerary;
